export default function LogoHeader({ className = '' }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 244 48"
      role="img"
      aria-label="DFPRO Hérault"
      className={`h-10 w-auto ${className}`}
      fill="none"
    >
      <g>
        <rect x="0" y="6" width="36" height="36" rx="9" fill="#143A5A" />
        <rect x="7" y="13" width="22" height="22" rx="2" fill="none" stroke="#FFFFFF" strokeWidth="1.8" />
        <line x1="18" y1="13" x2="18" y2="35" stroke="#FFFFFF" strokeWidth="1.8" />
        <rect x="9" y="15" width="7.5" height="18" rx="1" fill="#F25C54" />
        <rect x="16.4" y="21.5" width="1.7" height="5" rx="0.8" fill="#FFFFFF" />
        <path d="M23 38 h6" stroke="#F25C54" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M27 36 l2 2 l-2 2" fill="none" stroke="#F25C54" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <text x="46" y="29.5" fontFamily="Montserrat, 'Segoe UI', sans-serif" fontSize="23" fontWeight="700" letterSpacing="-0.4">
        <tspan fill="#143A5A">DFPRO</tspan>
        <tspan fill="#F25C54"> Hérault</tspan>
      </text>
      <text x="47" y="41" fontFamily="'Source Sans 3', sans-serif" fontSize="7.1" fontWeight="600" letterSpacing="2.3" fill="#586B7A">
        RÉPARATION BAIE COULISSANTE
      </text>
    </svg>
  );
}